import React, { Component } from "react";

import News_BannerTitle from "../../../layouts/news/News_BannerTitle";
import {
  Header,
  TopBar,
  BottomBar,
} from "../../../layouts/_admin/general/index";
import { firestore } from "../../../../helpers/Firebase";
import Image from "../../../layouts/inputs/Image";
import RichText from "../../../layouts/inputs/RichText";
import {
  modules,
  partnerStatuses,
  partnerTypes,
} from "../../../../helpers/constants";
import Images from "../../../layouts/inputs/Images";

class Admin_EditCities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      categories: [],
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "Gradovi",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/cities-list",
          titlelink: "Gradovi",
          border: "|",
          name: "Uređivanje gradova",
          heading: "Uređivanje gradova",
        },
      ],
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    const { location } = this.props;

    const params = new URLSearchParams(location.search);

    const ID = params.get("ID");

    if (ID) {
      firestore
        .doc(`Web/Corporate/DataBase/Cities/DataBase/${ID}`)
        .get()
        .then((snapshot) => {
          const data = snapshot.data();

          this.setState({
            data: {
              ...data,
              ID: snapshot.id,
            },
            loading: false,
          });
        });
    } else {
      this.setState({
        loading: false,
        data: {
          partnerName: "",
          classnames: "project-item croatia",
          country: "Hrvatska",
          partnerType: "Standard",
          partnerStatus: "Inactive",
          modules: [],
          images: [],
          description: "",
          order: 100,
        },
      });
    }
  }

  onSubmit() {
    this.setState({ loading: true });
    const { data } = this.state;
    const { history } = this.props;

    if (data.ID) {
      firestore
        .doc(`Web/Corporate/DataBase/Cities/DataBase/${data.ID}`)
        .set({
          ...data,
        })
        .then(() => {
          this.setState({ loading: false });
        });
    } else {
      firestore
        .collection("Web/Corporate/DataBase/Cities/DataBase")
        .add({
          ...data,
        })
        .then((doc) => {
          history.push(`/admin/cities-edit?ID=${doc.id}`);
          this.loadData();
        });
    }
  }

  onDelete() {
    const { data } = this.state;
    const { history } = this.props;

    firestore
      .doc(`Web/Corporate/DataBase/Cities/DataBase/${data.ID}`)
      .delete()
      .then(() => {
        history.push("/admin/cities-list");
      });
  }

  render() {
    const { history } = this.props;
    const { loading, data } = this.state;

    return (
      <div className="header-fixed sidebar-right header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <News_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={60}
                  data-mobile={60}
                  data-smobile={60}
                />

                {loading ? (
                  <div className="loading" />
                ) : (
                  <>
                    <div className="col-12 p-2">
                      <label>Partner name</label>
                      <input
                        className="col-12"
                        type="text"
                        onChange={(e) =>
                          this.setState({
                            data: { ...data, partnerName: e.target.value },
                          })
                        }
                        value={data.partnerName}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>Country</label>
                      <input
                        className="col-12"
                        type="text"
                        onChange={(e) =>
                          this.setState({
                            data: { ...data, country: e.target.value },
                          })
                        }
                        value={data.country}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>Classnames</label>
                      <input
                        className="col-12"
                        type="text"
                        onChange={(e) =>
                          this.setState({
                            data: { ...data, classnames: e.target.value },
                          })
                        }
                        value={data.classnames}
                      />
                    </div>

                    {/* <div className="col-12 p-2">
                      <label>Partner type</label>
                      <input
                        className="col-12"
                        type="text"
                        onChange={(e) =>
                          this.setState({
                            data: { ...data, partnerType: e.target.value },
                          })
                        }
                        value={data.partnerType}
                      />
                    </div> */}

                    <div className="col-12 p-2">
                      <label>Order</label>
                      <input
                        className="col-12"
                        type="number"
                        onChange={(e) =>
                          this.setState({
                            data: { ...data, order: e.target.value },
                          })
                        }
                        value={data.order}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>{`List Image (920x600)`}</label>
                      <Image
                        value={data.listImg}
                        updateValue={(val) =>
                          this.setState({ data: { ...data, listImg: val } })
                        }
                        refURL={`Web/Partners/Cities`}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>Description</label>
                      <RichText
                        value={data.description}
                        updateValue={(val) =>
                          this.setState({
                            data: { ...data, description: val },
                          })
                        }
                        refURL={`Web/Partners/Cities`}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>
                        Partner type
                        <select
                          value={data.partnerType}
                          onChange={(e) =>
                            this.setState({
                              data: { ...data, partnerType: e.target.value },
                            })
                          }
                        >
                          {partnerTypes.map((partnerType) => (
                            <option value={partnerType}>{partnerType}</option>
                          ))}
                        </select>
                      </label>
                    </div>

                    <div className="col-12 p-2">
                      <label>Moduli</label>
                      <div check="true" style={{ padding: "0" }}>
                        {modules.map((module) => (
                          <div key={`checkbox_option_wrapper_${module}`}>
                            <input
                              className="ml-2"
                              type="checkbox"
                              key={`checkbox_option_${module}`}
                              id={`checkbox_option_${module}`}
                              checked={data.modules.includes(module)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  const newModules = [...data.modules];
                                  newModules.push(module);
                                  this.setState({
                                    data: {
                                      ...data,
                                      modules: newModules,
                                    },
                                  });
                                } else {
                                  let newModules = [...data.modules];
                                  newModules = newModules.filter(
                                    (x) => x !== module
                                  );
                                  this.setState({
                                    data: {
                                      ...data,
                                      modules: newModules,
                                    },
                                  });
                                }
                              }}
                              inline="true"
                            />
                            <label
                              key={`checkbox_option_label_${module}`}
                              className="ml-2"
                            >
                              {module}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="col-12 p-2">
                      <label>Images</label>
                      <Images
                        refURL={`Web/Partners/Cities`}
                        value={data.images}
                        addImage={(img) => {
                          this.setState({
                            data: {
                              ...this.state.data,
                              images: [...this.state.data.images, img],
                            },
                          });
                        }}
                        removeImage={(img) => {
                          this.setState({
                            data: {
                              ...this.state.data,
                              images: [
                                ...this.state.data.images.filter(
                                  (i) => i !== img
                                ),
                              ],
                            },
                          });
                        }}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>
                        Partner status
                        <select
                          value={data.partnerStatus}
                          onChange={(e) =>
                            this.setState({
                              data: { ...data, partnerStatus: e.target.value },
                            })
                          }
                        >
                          {partnerStatuses.map((partnerStatus) => (
                            <option value={partnerStatus}>
                              {partnerStatus}
                            </option>
                          ))}
                        </select>
                      </label>
                    </div>

                    <div className="col-12 p-2">
                      <input
                        type="button"
                        onClick={() => {
                          history.push("/admin/cities-list");
                        }}
                        value="Cancel"
                      />

                      <input
                        className="float-right"
                        type="button"
                        onClick={() => this.onSubmit()}
                        value="Submit"
                      />

                      {data.ID && (
                        <input
                          className="float-right"
                          type="button"
                          onClick={() => this.onDelete()}
                          value="Delete"
                        />
                      )}
                    </div>
                  </>
                )}

                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={80}
                  data-mobile={60}
                  data-smobile={60}
                />
              </div>
            </div>
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Admin_EditCities;
